import { AHIcon, AHText, Box, ColorType, useTime } from "arkh";
import { Duration, DateTime } from "luxon";
import React, { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { WidgetTodoListItemDeadline_todo$key } from "./__generated__/WidgetTodoListItemDeadline_todo.graphql";
function TodoDeadlineIndicator(props: {
  children: React.ReactNode;
  tint: ColorType;
}) {
  return (
    <Box style={{ flexDirection: "row", alignItems: "center" }}>
      <AHIcon
        type="deadline"
        size="xxsmall"
        color={props.tint}
        spaceRight="xsmall"
      />
      <AHText color={props.tint} type="detail">
        {props.children}
      </AHText>
    </Box>
  );
}

export function WidgetTodoListItemDeadline(props: {
  todo: WidgetTodoListItemDeadline_todo$key;
}) {
  const { expireAtFormatted, expireAt } = useFragment(
    graphql`
      fragment WidgetTodoListItemDeadline_todo on Todo {
        expireAt
        expireAtFormatted
      }
    `,
    props.todo
  );
  const now = useTime(Duration.fromObject({ seconds: 15 }).as("milliseconds"));
  const isExpired = useMemo(
    () => !!(expireAt && DateTime.fromISO(expireAt) < now),
    [expireAt, now]
  );

  if (!expireAtFormatted) {
    return null;
  }

  const tint = isExpired ? "status-negative" : "text-washed";
  return (
    <TodoDeadlineIndicator tint={tint}>
      {expireAtFormatted}
    </TodoDeadlineIndicator>
  );
}
